import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useBrand } from "@/context/BrandContext";

const contextMessages = {
  "/": "Hi, I would like to know more about the Mothers by Mothers children’s lunch plans.",
  "/meals": "Hi, I have a question about your breakfast and lunch meals.",
  "/plans": "Hi, I would like to ask about the Mothers by Mothers weekly lunch plan.",
  "/how-it-works": "Hi, I would like to understand how the subscription works.",
  "/food-standards": "Hi, I have a question about your food standards and ingredients.",
  "/our-story": "Hi, I read your story and would like to know more.",
  "/mothers-supporting-mothers": "Hi, I would like to know about cooking opportunities with your team.",
  "/faqs": "Hi, I have a question that was not covered in your FAQs.",
  "/contact": "Hi, I would like to speak to someone about a children’s lunch subscription.",
  "/get-started": "Hi, I would like to start a meal plan for my child.",
  "/delivery-areas": "Hi, I would like to check whether you deliver to my area in Pune.",
  "/checkout": "Hi, I need help completing my subscription order.",
};

export const WhatsAppButton = () => {
  const brand = useBrand();
  const { pathname } = useLocation();
  const message =
    contextMessages[pathname] ||
    (pathname.startsWith("/legal")
      ? "Hi, I have a question about your policies."
      : contextMessages["/"]);

  return (
    <a
      href={`https://wa.me/${brand.contact.whatsapp}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-5 right-5 z-40 flex min-h-[54px] items-center gap-2.5 rounded-full bg-coralInk px-5 text-white shadow-softLg transition-transform duration-300 hover:-translate-y-1 sm:bottom-7 sm:right-7"
    >
      <MessageCircle className="h-5 w-5 text-white" aria-hidden="true" />
      <span className="text-sm font-extrabold">Chat with us</span>
    </a>
  );
};

export default WhatsAppButton;
